import React from 'react';
import { BankIDComponent } from '../BankIDComponent';

import type { BankIDComponentProps } from '../BankIDComponent';

export interface BankIDAuthProps extends Omit<BankIDComponentProps, 'subtitle'> {
    subtitle?: string;
}

const BankIDAuth: React.FC<BankIDAuthProps> = (props) => {
    return <BankIDComponent {...props} />;
};

export default BankIDAuth;
